
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g40iwNjKbyWOv5UlNq_5_45UhVSV6APdG1hLaylK3VFwJcMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexkkKAkeMysZKJh5VbvUdBepu4fc1vrRxnsg33kzm6yfgMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search4kBBv_wLEamFU7xeq1N_45xblTEjkLoX6tbxZbOyprbCcMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexSjHM11kgdgz0jHTXVOn1RON87E3YWiPhUqILxRBJhL4Meta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93LrBi0e6hpeoBXft2zbaMdveZ6TCk0Z6Uz3tkZkPCcPwMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexHvpKUiQ7PUxbHOTnM2UpvuCARxV58DuiHVCTOI_2yvoMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_937swKgo_52Z_455tnMLnyXVeHI8bxbRMBne0vOEzz_45GB1oMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexiJLiSM1IwiBB_456XX0Bf8l_rdQgJNtrKZTO9FF_fvmH4Meta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93mgwhKUPY4DBLfu8EMsmo7KhBy3rJNPijwcOafGExHPsMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexxdYndNx2vr9TgZYs26Fp8KejXMyXpqk9BoyfIOKb0ecMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexs85ZE4OIZwo3sjVHu2abveO5sSffwboQHNSORlNLnqcMeta } from "/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexHvpKUiQ7PUxbHOTnM2UpvuCARxV58DuiHVCTOI_2yvoMeta || {},
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexiJLiSM1IwiBB_456XX0Bf8l_rdQgJNtrKZTO9FF_fvmH4Meta || {},
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexxdYndNx2vr9TgZYs26Fp8KejXMyXpqk9BoyfIOKb0ecMeta || {},
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexs85ZE4OIZwo3sjVHu2abveO5sSffwboQHNSORlNLnqcMeta || {},
    component: () => import("/codebuild/output/src2562314900/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]